var _path, _path2, _path3, _path4, _rect, _line, _line2, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculadoraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H32V28C32 30.2091 30.2091 32 28 32H16V16Z",
    fill: "#4676FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L-1.90735e-06 16L-8.58275e-07 4C-6.65146e-07 1.79086 1.79086 -2.88528e-07 4 -9.53992e-08L16 9.53674e-07L16 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16L16 16L16 -4.4509e-07L28 6.03983e-07C30.2091 7.97112e-07 32 1.79086 32 4L32 16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32L4 32C1.79086 32 -1.75079e-06 30.2091 -1.55766e-06 28L-5.08584e-07 16L16 16L16 32Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#27262A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: -2.18557e-8,
    x2: 15.5,
    y2: 32,
    stroke: "#27262A"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.0017,
    y1: 15.9834,
    x2: 0.822253,
    y2: 16.0892,
    stroke: "#27262A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5127 9.02539H27.0768",
    stroke: "#27262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5127 22.1543H27.0768",
    stroke: "#27262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5127 25.4365H27.0768",
    stroke: "#27262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41919 5.74316V12.7354",
    stroke: "#27262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92285 9.23926H11.915",
    stroke: "#27262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6987 21.3447L5.7545 26.289",
    stroke: "#27262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75439 21.3447L10.6986 26.289",
    stroke: "#27262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadoraIcon);
export default __webpack_public_path__ + "static/media/calculadora-icon.a428779d558e397f34b47eed1342f1c7.svg";
export { ForwardRef as ReactComponent };